// src/sectors/pilates/reports/staff/hooks/useTrainerSessionsReport.js
import { useQuery } from '@tanstack/react-query';
import { reportsApi } from 'sectors/pilates/reports/api/reportsApi';

export const reportsKeys = {
  trainerSessions: (trainerId, from, to, limit) => [
    'reports',
    'trainerSessions',
    String(trainerId ?? ''),
    String(from ?? ''),
    String(to ?? ''),
    String(limit ?? ''),
  ],
};

export function useTrainerSessionsReport({ trainerId, from, to, limit = 200 } = {}) {
  return useQuery({
    queryKey: reportsKeys.trainerSessions(trainerId, from, to, limit),
    queryFn: () => reportsApi.listTrainerSessions({ trainerId, from, to, limit }),
    enabled: !!trainerId, // trainer seçmeden istek yok
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
}
